import { useMemo } from 'react';
import moment from 'moment';

import { FORM_MAP } from '@/pages/dashboard/pages/realtime/_config/constant';


const useRealtimeRevenueDefaultFilterVal = (timeZone: string) => {
  const defaultFilterValue = useMemo(() => {
    return {
      [FORM_MAP.SINGLE_TIME]: moment().utcOffset(timeZone).format('YYYY-MM-DD'),
      [FORM_MAP.CONTRAST_DAY]: moment().utcOffset(timeZone).subtract(7, 'day').format('YYYY-MM-DD'),
      [FORM_MAP.ZONE]: ['255'],
      [FORM_MAP.REGION]: {
        regions: [],
        markets: ['255'],
        region_type: 'market',
      },
      [FORM_MAP.SYSTEM]: ['255'],
      [FORM_MAP.CHANNEL]: ['255'],
      [FORM_MAP.LANGUAGE]: ['255'],
    }
  }, [timeZone])
  return defaultFilterValue;
}


export default useRealtimeRevenueDefaultFilterVal;